import { inject, Injectable } from '@angular/core';
import { AuthService } from '@isophi/core-legacy';
import { DemoSwitchKindergartenResponse, SwitchDemoKindergartenService } from '@isophi/mng-api';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs';

import { environment } from '../../../environments/environment';
import { KindergartenService } from './kindergarten.service';

export type DemoSwitchKindergartenTAppResponse = DemoSwitchKindergartenResponse & { redirect_url: string };

@Injectable({
  providedIn: 'root',
})
export class SwitchToDemoKindergartenService {
  private readonly switchDemoKindergartenService = inject(SwitchDemoKindergartenService);

  private readonly kindergartenService = inject(KindergartenService);

  private readonly spinner = inject(NgxSpinnerService);

  private readonly authService = inject(AuthService);

  switchToDemoKindergarten(): void {
    this.spinner.show();
    this.switchDemoKindergartenService
      .switchDemoKindergartenRetrieve(environment.client_id)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe((response: DemoSwitchKindergartenTAppResponse) => {
        const url = new URL(response.redirect_url);
        if (!this.kindergartenService.loggedKindergarten.isDemo) {
          url.searchParams.append('showDemoPopup', 'true');
          url.searchParams.append('originUserUuid', this.authService.loggedUser.uuid);
        }

        const a = document.createElement('a');
        a.href = url.toString();
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  }
}
